
const sidebar = (tenantId, { isSuperAdmin = false, hasMultipleTenants = false } = {}) => [
  ...(isSuperAdmin ? [{
    title: "Admin",
    icon: "bi-shield-lock-fill",
    childrens: [
      {
        title: "Platform Admin",
        icon: "bi-speedometer2",
        path: `/${tenantId}/admin`,
      },
      {
        title: "Test Runner",
        icon: "bi-bug",
        path: `/${tenantId}/admin/tests`,
      },
    ],
  }] : []),
  {
    title: "Dashboard",
    icon: "bi-house-door-fill",
    childrens: [
      {
        title: "Home",
        icon: "bi-house-fill",
        path: `/${tenantId}/dashboard`,
      },
      {
        title: "Notes",
        icon: "bi-sticky-fill",
        path: `/${tenantId}/notes`,
      },
      {
        title: "Analytics",
        icon: "bi-bar-chart-fill",
        path: `/${tenantId}/analytics`,
      },
      {
        title: "Social Inbox",
        icon: "bi-inbox-fill",
        path: `/${tenantId}/replies`,
      },
      {
        title: "Inbox Automation",
        icon: "bi-robot",
        path: `/${tenantId}/inbox-automation`,
      },
      {
        title: "Reports",
        icon: "bi-clipboard-data",
        path: `/${tenantId}/reports`,
      },
      {
        title: "Transaction Report",
        icon: "bi-receipt",
        path: `/${tenantId}/transactions`,
      },
      ...(hasMultipleTenants ? [{
        title: "Switch Tenant",
        icon: "bi-arrow-left-right",
        action: "switchTenant",
      }] : []),
    ],
  },
  {
        title: "Post",
        icon: "bi-camera-fill",
        childrens: [
      {
        title: "New Post",
        icon: "bi-send-plus-fill",
        path: `/${tenantId}/post/new`,
      },
      {
        title: "New Text Post",
        icon: "bi-chat-left-text-fill",
        path: `/${tenantId}/post/text`,
      },
      {
        title: "Timeline Posts",
        icon: "bi-hourglass-split",
        path: `/${tenantId}/post`,
      },
      {
        title: "Scheduled Posts",
        icon: "bi-clock-fill",
        path: `/${tenantId}/media/scheduled-posts`,
      },
      {
        title: "Bulk Schedule",
        icon: "bi-filetype-csv",
        path: `/${tenantId}/media/bulk-schedule`,
      },
      {
        title: "RSS Feeds",
        icon: "bi-rss-fill",
        path: `/${tenantId}/media/rss-feeds`,
      },
      {
        title: "Approvals",
        icon: "bi-check2-square",
        path: `/${tenantId}/approvals`,
      },
    ],
  },
  {
    title: "Marketing",
    icon: "bi-megaphone-fill",
    childrens: [
      {
        title: "Campaigns",
        icon: "bi-bullseye",
        path: `/${tenantId}/campaigns`,
      },
      {
        title: "Content Calendar",
        icon: "bi-calendar-week-fill",
        path: `/${tenantId}/content-calendar`,
      },
      {
        title: "Promoters",
        icon: "bi-person-badge-fill",
        path: `/${tenantId}/promoters`,
      },
      {
        title: "Public Page",
        icon: "bi-globe2",
        path: `/${tenantId}/public-hub`,
      },
      {
        title: "Forms",
        icon: "bi-ui-checks",
        path: `/${tenantId}/forms`,
      },
      {
        title: "Audience",
        icon: "bi-megaphone-fill",
        path: `/${tenantId}/audience`,
      },
      // Social Inbox lives under Dashboard only — it was duplicated here.
    ],
  },
  {
    title: "Events",
    icon: "bi-calendar2-event-fill",
    childrens: [
      {
        title: "Events",
        icon: "bi-calendar3-week",
        path: `/${tenantId}/events`,
      },
      {
        title: "Event Hub",
        icon: "bi-grid-1x2-fill",
        path: `/${tenantId}/eventHub`,
      },
      {
        title: "Add Event",
        icon: "bi-calendar2-plus-fill",
        path: `/${tenantId}/eventAdd`,
      },
      {
        title: "Event Actions",
        icon: "bi-lightning-charge-fill",
        path: `/${tenantId}/eventActions`,
      },
      {
        title: "Volunteers",
        // bi-person-raised-hand needs bootstrap-icons 1.10+; public/index.html loads 1.8.1.
        icon: "bi-hand-thumbs-up-fill",
        path: `/${tenantId}/volunteers`,
      },
      {
        title: "Event History",
        icon: "bi bi-hourglass-split",
        path: `/${tenantId}/eventHistory`,
      },
      {
        title: "Calendar",
        icon: "bi-calendar3",
        path: `/${tenantId}/calendar`,
      },
    ],
  },
  ...(isSuperAdmin ? [{
    title: "Shop",
    icon: "bi-shop",
    childrens: [
      {
        title: "Vinted",
        icon: "bi-tag-fill",
        path: `/${tenantId}/vinted`,
      },
      {
        title: "Etsy",
        icon: "bi-bag-fill",
        path: `/${tenantId}/etsy`,
      },
    ],
  }] : []),
  {
    title: "Membership",
    icon: "bi-person-badge-fill",
    childrens: [
      {
        title: "Members",
        icon: "bi-people-fill",
        path: `/${tenantId}/members`,
      },
      {
        title: "Add Member",
        icon: "bi-person-plus-fill",
        path: `/${tenantId}/memberAdd`,
      },
      {
        title: "Donations",
        icon: "bi-heart-fill",
        path: `/${tenantId}/donations`,
      },
    ],
  },
  {
    title: "Settings",
    icon: "bi-gear-fill",
    childrens: [
      {
        title: "Add User",
        icon: "bi-person-plus-fill",
        path: `/${tenantId}/userAdd`,
      },
      {
        title: "Tenant Users",
        icon: "bi-people-fill",
        path: `/${tenantId}/tenantUsers`,
      },
      {
        title: "Imports",
        icon: "bi-upload",
        path: `/${tenantId}/imports`,
      },
      {
        title: "Developers",
        icon: "bi-code-slash",
        path: `/${tenantId}/developers`,
      },
      {
        title: "Social Media",
        icon: "bi-share",
        path: `/${tenantId}/integrations`,
      },
      {
        title: "Account",
        icon: "bi-gear-fill",
        path: `/${tenantId}/settings`,
      },
      {
        title: "Reset Password",
        icon: "bi-key-fill",
        path: `/${tenantId}/reset-password`,
      },
      {
        title: "Terms Of Use",
        icon: "bi-file-earmark-text",
        path: "/termsofuse",
      },
      {
        title: "Privacy Policy",
        icon: "bi-shield-lock-fill",
        path: "/privacypolicy",
      },
      // {
      //   title: "Profile",
      //   icon: "bi-person-circle",
      //   path: "/profile",
      // },
      {
        title: "Billing",
        icon: "bi-credit-card-2-front-fill",
        path: `/${tenantId}/billing`,
      },
      {
        title: "Tax Center",
        icon: "bi-calculator-fill",
        path: `/${tenantId}/tax-center`,
      },
      // {
      //   title: "Notifications",
      //   icon: "bi-bell-fill",
      //   path: "/settings/notifications",
      // },
    ],
  },
];

export default sidebar;

